import React from 'react';
import CompaniesDetails from 'components/companies/Details';
import Details from 'components/vacancies/Details';

import {Button} from 'react-bootstrap'
import { Modal } from 'react-bootstrap';
export default props => {
  return (
    <div>
      <Modal show={props.selected} onHide={props.selectOne()}>
        <Modal.Header closeButton >
          <Modal.Title>Indepth: Vacancy</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Details {...props} />
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={props.selectOne()}>Close</Button>
        </Modal.Footer>

      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/vacancies/Indepth.jsx